export default {
    'searchList': {
        'searchTxt': [{
            'name': '客户订单号',
            'value': 'ettaSoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 7,
            'unfold': true,
            'span': 7
        }, {
            'name': '发车单号',
            'value': 'ettaDoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '运输单号',
            'value': 'ettaNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '收货联系人',
                'prop': 'ettaToContactName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系手机',
                'prop': 'ettaToContactMobile',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系电话',
                'prop': 'ettaToContactTel',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单号',
                'prop': 'ettaNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户订单号',
                'prop': 'ettaSoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '集拼号',
                'prop': 'ettaAssighNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '排队ID',
                'prop': 'queueCode',
                'sort': true,
                'width': '100px'
            },
            {
                'label': '合同编号',
                'prop': 'ettaContractNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备号',
                'prop': 'deviceName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单状态',
                'prop': 'ettaStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单送达地址',
                'prop': 'ettaEtorToEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单来源',
                'prop': 'etta2b2cType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': 'C端配送方式',
                'prop': 'ettaDeliveryTypeCodeType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否供方预约',
                'prop': 'etIsSupllyAppointmentType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '紧急程度',
                'prop': 'ettaLevelType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '线路',
                'prop': 'ettaEblnLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '体积',
                'prop': 'ettaVolume',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '重量',
                'prop': 'ettaWeight',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '数量',
                'prop': 'ettaQuantity',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输方式',
                'prop': 'ettaTranTypeNew',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输产品',
                'prop': 'etCimsTmsProduct',
                'sort': true,
                'width': '148px'
            },
            {
                'label': 'CIMS集拼号',
                'prop': 'cimsVampNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '集拼单数',
                'prop': 'etCimsAssighNums',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求发货时间',
                'prop': 'ettaReqDeliveryDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求送达时间',
                'prop': 'ettaReqArrivalDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否预约',
                'prop': 'ettaReservationType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户预约单号',
                'prop': 'ettaReservationNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约送货时间',
                'prop': 'ettaReservationTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单类型',
                'prop': 'ettaOrderTypeName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货地',
                'prop': 'ettaEtorFromEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货仓库',
                'prop': 'ettaOutWhName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货单位',
                'prop': 'ettaConsigneeEbspNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '提货区域',
                'prop': 'esstFromCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '送达区域',
                'prop': 'esstToCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '开票单位',
                'prop': 'ettaSourceCustomerCode',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '营销中心名称',
                'prop': 'ettaProductCenterName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车单号',
                'prop': 'ettaDoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '备注',
                'prop': 'ettaRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '物流订单号',
                'prop': 'ettaOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备绑定时间',
                'prop': 'deviceBundTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备回收时间',
                'prop': 'deviceBackTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约一级原因',
                'prop': 'ettaMarkOne',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约二级原因',
                'prop': 'ettaMarkTwo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约备注',
                'prop': 'ettaMarkRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否在始发地围栏',
                'prop': 'beginLandRail',
                'type': 'select',
                'optionNum': '',
                'options': [
                    { label: '否', value: '0' },
                    { label: '是', value: '1' }
                ],
                'sort': true,
                'width': 200
            },
            {
                'label': '是否在目的地围栏',
                'prop': 'endLandRail',
                'type': 'select',
                'optionNum': '',
                'options': [
                    { label: '否', value: '0' },
                    { label: '是', value: '1' }
                ],
                'sort': true,
                'width': 150
            },
            {
                'label': '触碰目的地围栏时间',
                'prop': 'endLandRailTime',
                'sort': true,
                'width': 160
            }
        ],
        'action':
            [
                {
                    'type': 'text',
                    'label': '设备绑定',
                    'size': 'mini',
                    'event': 'configBind',
                    'ifHas': '05010205'
                },
                {
                    'type': 'text',
                    'label': '取消绑定',
                    'size': 'mini',
                    'event': 'configCancel',
                    'ifHas': '05010206'
                }
            ],
        'leftOperation': true,
        'leftWidth': 150
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '集拼号',
            'value': 'ettaAssighNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#ettaCustomEbcuNo', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '线路',
            'value': 'eblnLineName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' }
            ],
            'tableConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' },
                { 'prop': 'eblnRatedMileage', 'value': '额定里程' }
            ],
            'advanceUrl': '/ebLine/search',
            'cbParams': ['eblnLineCode#ettaEblnCode', 'eblnLineName', 'eblnRatedMileage'],
            'span': 4
        }, {
            'name': '运输单状态',
            'value': 'ettaStatus',
            'data': '00',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'SYS_TRANSPORT_TASK_STATUS'
        }, {
            'name': '要求发货时间',
            'value': 'shipmentsTime',
            'startTime': 'ettaReqDeliveryDateF',
            'endTime': 'ettaReqDeliveryDateT',
            'startPlaceholder': '要求发货开始日期',
            'endPlaceholder': '要求发货结束日期',
            'type': 'time',
            'unfold': false,
            'span': 7
        }, {
            'name': '物流订单号',
            'value': 'ettaOrderNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '合同编号',
            'value': 'ettaContractNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '设备号',
            'value': 'deviceName',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '订单来源',
            'value': 'ettaOrderSource',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'SYS_TMS_ORDER_SOURCE'
        }, {
            'name': 'C端配送方式',
            'value': 'ettaDeliveryTypeCode',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'OMS_TRANS_TYPE'
        }
    ]
};
